export const sanitizeEmails = (emails: string[] = []): string[] => {
  return emails.map((email) => email.trim()).filter((email) => email !== '');
};

export const normalizeEmail = (email: string): string => {
  return email.trim().toLowerCase();
};

export const hasDuplicateEmails = (
  first: string[],
  second: string[]
): boolean => {
  if (first.length !== second.length) {
    return false;
  }
  return first.every((email, index) => email === second[index]);
};

// Helper function to check if an email exists in an array (case-insensitive)
export const emailExists = (email: string, emailArray: string[]): boolean => {
  const normalizedEmail = email.toLowerCase().trim();
  return emailArray.some(
    (existingEmail) => existingEmail.toLowerCase().trim() === normalizedEmail
  );
};
